import styled from 'styled-components';
import { Modal, Flex, Text, Button } from '@/app/ui';
import { translate } from '@/app/i18n';
import type { SubscriptionInfo } from '@/app/ui/organisms/SubscriptionCard/SubscriptionCard';
import Colors from '@/app/styles/Colors';
import SubscriptionTypeSelectComponent from '@/app/ui/organisms/SignUp/Subscription/SubscriptionTypeSelectComponent';

interface ManageSubscriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectSubscription: (subscription: SubscriptionInfo) => void;
  onCancelSubscription: () => void;
}

const SubscriptionTypeSelectComponentStyled = styled(SubscriptionTypeSelectComponent)`
  h2 {
    color: ${Colors.black} !important;
    padding-left: 0 !important;
  }
`;

const ManageSubscriptionModal = ({
  isOpen,
  onClose,
  onSelectSubscription,
  onCancelSubscription,
}: ManageSubscriptionModalProps) => (
  <Modal isOpen={isOpen} position="center" size="sm">
    <Flex.Container flexDirection="column" style={{ padding: '2rem 3rem' }}>
      <SubscriptionTypeSelectComponentStyled setSelectedSubscription={onSelectSubscription} />

      <Button
        $transparent
        $variant="cancel"
        onClick={onCancelSubscription}
        style={{ marginTop: '1rem', alignSelf: 'flex-start' }}
      >
        <Text.Span fontWeight={700} style={{ color: Colors.red, textDecoration: 'underline' }}>
          {translate('SUBSCRIPTION_INFO.CANCEL_SUBSCRIPTION')}
        </Text.Span>
      </Button>

      <Flex.Container justifyContent="flex-end">
        <Button $size="lg" $transparent $variant="primary" onClick={onClose}>
          <Text.Span fontWeight={700} style={{ width: '80px' }}>
            {translate('PROFILE_INFO.CANCEL')}
          </Text.Span>
        </Button>
      </Flex.Container>
    </Flex.Container>
  </Modal>
);

export default ManageSubscriptionModal;
